import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/code/apps/web/modules/auth/forgot-password/forgot-password-view.tsx");
